import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-478808fa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "m-content-wrap" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"u-title\" data-v-478808fa>为什么要做学习笔记？</div><div class=\"m-chapter\" data-v-478808fa> 6-12 岁是养成良好习惯、培养学习品质的关键期 </div><div class=\"m-chapter m-chapter-2\" data-v-478808fa> 做笔记时手、眼、耳、脑多感官并用，既提高学习效率，又培养学生的逻辑思维能力 </div><div class=\"u-title\" data-v-478808fa>怎么做学习笔记</div><div class=\"m-chapter m-chapter-2\" data-v-478808fa> 采用思维导图笔记法更容易记忆、理解和复习，做笔记时请注意笔记工整哦～ </div><div class=\"note-pic-title\" data-v-478808fa>优秀笔记案例:</div>", 6)
const _hoisted_8 = { class: "note-pic-list" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "img-load-error" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "error-title" }, "学而思"),
  /*#__PURE__*/_createElementVNode("div", { class: "error-desc" }, "自主学习新体验")
], -1))
const _hoisted_10 = { class: "m-upload-btn-wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_image = _resolveComponent("van-image")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["m-note-strategy", {'m-first-show': $setup.firstShow && !$props.progress}])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_8, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.notePicList, (item, index) => {
          return (_openBlock(), _createBlock(_component_van_image, {
            onClick: ($event: any) => ($setup.handlePreview(index)),
            class: "image",
            src: item,
            key: 'note-' + index
          }, {
            error: _withCtx(() => [
              _hoisted_9
            ]),
            _: 2
          }, 1032, ["onClick", "src"]))
        }), 128))
      ])
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", {
        class: "u-upload-btn",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.callUploadAction && $setup.callUploadAction(...args)))
      }, "我知道了，上传笔记")
    ], 512), [
      [_vShow, $setup.firstShow && !$props.progress]
    ])
  ], 2))
}